import { render, staticRenderFns } from "./ContactEdit.vue?vue&type=template&id=5d0ad8a6&scoped=true&"
import script from "./ContactEdit.vue?vue&type=script&lang=js&"
export * from "./ContactEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContactEdit.vue?vue&type=style&index=0&id=5d0ad8a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0ad8a6",
  null
  
)

export default component.exports